// extracted by mini-css-extract-plugin
export default {"nav":"AdminNav_nav__LL5mN","link":"AdminNav_link__6sHUy","linkActive":"AdminNav_linkActive__jMQA4"};